import React, { useContext, useState, useRef, useEffect } from 'react';
import { UserContext } from '../../context';
import { useHistory } from 'react-router-dom';
import Navbar from 'react-bootstrap/Navbar';
import CnpjSelector from '../CNPJSelector';
import SalesDataList from '../cards/vendalista';

const Menu = () => {
  const context = useContext(UserContext);
  const logado  = context.isLogger;
  const [selectedCnpj, setSelectedCnpj]     = useState('');
  const [showCnpjSelector, setShowCnpjSelector] = useState(false);
  const [showMenu, setShowMenu]             = useState(false);
  const menuRef  = useRef(null);
  const history  = useHistory();

  useEffect(() => {
    const handleClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setShowMenu(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const logout = () => {
    localStorage.removeItem('delphireact-token');
    context.alterLogin(false);
    history.push('/login');
  };

  const clearCredentials = () => {
    const confirmation = window.confirm('Deseja excluir dados de acesso?');
    if (confirmation) {
      localStorage.removeItem('delphireact-token');
      localStorage.removeItem('nome-token');
      localStorage.removeItem('cnpj-token');
      localStorage.removeItem('cnpjs');
      context.alterLogin(false);
      history.push('/login');
    }
  };

  if (logado) {
    const storedCnpjs = JSON.parse(localStorage.getItem('cnpjs')) || [];

    const menuItems = [
      {
        label: 'Trocar empresa',
        icon: 'fa-arrows-rotate',
        action: () => { setShowCnpjSelector(v => !v); setShowMenu(false); },
      },
      {
        label: 'Limpar credenciais',
        icon: 'fa-trash-can',
        action: () => { setShowMenu(false); clearCredentials(); },
        danger: true,
      },
      {
        label: 'Sair',
        icon: 'fa-right-from-bracket',
        action: () => { setShowMenu(false); logout(); },
      },
    ];

    return (
      <div style={{ minHeight: '100vh', backgroundColor: 'var(--bg-primary)' }}>

        {/* Navbar */}
        <Navbar
          fixed="top"
          style={{ backgroundColor: '#0b1120', borderBottom: '1px solid var(--border)', padding: 0, height: 52 }}
        >
          <Navbar.Brand href="/" style={{ display: 'flex', alignItems: 'center', gap: 10, marginRight: 'auto', marginLeft: 16, padding: 0, minWidth: 0, overflow: 'hidden' }}>
            <img
              src="/logpng.jpg"
              height="42"
              className="d-inline-block align-top"
              alt="Compsoft"
              style={{ borderRadius: 4, flexShrink: 0 }}
            />
            <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.3, minWidth: 0 }}>
              <span style={{ color: 'var(--primary-light)', fontWeight: 600, fontSize: '0.72rem', letterSpacing: '0.08em', textTransform: 'uppercase', whiteSpace: 'nowrap' }}>
                <i className="fas fa-gauge-high" style={{ marginRight: 4 }} />Dashboard
              </span>
              <span style={{ color: 'var(--text-secondary)', fontWeight: 600, fontSize: '0.72rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {localStorage.getItem('nome-token')}
              </span>
            </div>
          </Navbar.Brand>

          {/* hambúrguer */}
          <div ref={menuRef} style={{ position: 'relative', marginRight: 16 }}>
            <button
              className="btn-outline-dash"
              style={{ padding: '6px 11px', fontSize: '0.85rem' }}
              onClick={() => setShowMenu(v => !v)}
              aria-label="Menu"
            >
              <i className="fas fa-bars" />
            </button>

            {showMenu && (
              <div style={{
                position: 'absolute',
                top: 'calc(100% + 6px)',
                right: 0,
                background: '#1e293b',
                border: '1px solid rgba(255,255,255,0.1)',
                borderRadius: 10,
                padding: '4px 0',
                minWidth: 200,
                zIndex: 2000,
                boxShadow: '0 8px 28px rgba(0,0,0,0.45)',
              }}>
                {menuItems.map(({ label, icon, action, danger }) => (
                  <button
                    key={label}
                    onClick={action}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 10,
                      width: '100%',
                      background: 'none',
                      border: 'none',
                      padding: '10px 16px',
                      fontSize: '0.82rem',
                      color: danger ? 'var(--danger)' : 'var(--text-secondary)',
                      cursor: 'pointer',
                      textAlign: 'left',
                      transition: 'background 0.12s, color 0.12s',
                    }}
                    onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.05)'; if (!danger) e.currentTarget.style.color = '#f1f5f9'; }}
                    onMouseLeave={e => { e.currentTarget.style.background = 'none'; e.currentTarget.style.color = danger ? 'var(--danger)' : 'var(--text-secondary)'; }}
                  >
                    <i className={`fas ${icon}`} style={{ width: 14, textAlign: 'center' }} />
                    {label}
                  </button>
                ))}
              </div>
            )}
          </div>
        </Navbar>

        {/* Page content */}
        <div className="page-content">

          {/* CNPJ selector — visível só ao trocar empresa */}
          {showCnpjSelector && (
            <div className="mb-3">
              <div className="company-bar">
                <CnpjSelector
                  cnpjs={storedCnpjs}
                  onSelect={(cnpj) => {
                    setShowCnpjSelector(false);
                    setSelectedCnpj(cnpj);
                  }}
                />
              </div>
            </div>
          )}

          {/* Monthly evolution */}
          <div className="mb-3">
            <SalesDataList selectedCnpj={selectedCnpj} />
          </div>
        </div>
      </div>
    );
  }

  return '';
};

export default Menu;
